import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'not-found',
    pathMatch: 'full'
  },
  {
    path: 'not-found',
    loadComponent: () => import('./features/not-found/not-found.component').then(m => m.NotFoundComponent)
  },
  {
    path: ':calendarId',
    children: [
      {
        path: 'not-found',
        loadComponent: () => import('./features/not-found/not-found.component').then(m => m.NotFoundComponent)
      },
      {
        path: 'login',
        loadComponent: () => import('./features/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: 'verify',
        loadComponent: () => import('./features/verify/verify.component').then(m => m.VerifyComponent)
      },
      {
        path: 'create-profile',
        loadComponent: () => import('./features/create-profile/create-profile.component').then(m => m.CreateProfileComponent)
      },
      {
        path: 'confirm-booking',
        canActivate: [authGuard],
        loadComponent: () => import('./features/confirm-booking/confirm-booking.component').then(m => m.ConfirmBookingComponent)
      },
      {
        path: 'home',
        loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent)
      },
      {
        path: 'my-appointments',
        canActivate: [authGuard],
        loadComponent: () => import('./features/my-appointments/my-appointments.component').then(m => m.MyAppointmentsComponent)
      },
      {
        path: ':appointmentTypeId',
        loadComponent: () => import('./features/calendar-booking/calendar-booking.component').then(m => m.CalendarBookingComponent)
      },
      {
        path: '**',
        redirectTo: 'home'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'not-found',
  }
];
